// File icons
import excelIcon from "../../../assets/fileIcons/Excel.svg";
import emailIcon from "../../../assets/fileIcons/Email.svg";
import wordIcon from "../../../assets/fileIcons/Word.svg";
import pptIcon from "../../../assets/fileIcons/PowerPoint.svg";
import pdfIcon from "../../../assets/fileIcons/pdf.svg";
import otherFormat from "../../../assets/fileIcons/Document.svg";

// File extension arrays
export const powerPointExt = ["ppt", "pptx"];
export const wordExt = ["doc", "docx"];
export const excelExt = ["xls", "xlsx"];
export const emailExt = ["msg", "eml"];
export const imageExt = ["png", "jpeg", "jpg", "gif"];

// Get file extension
export const getFileExtension = (name = "") =>
  name.split(".").pop()?.toLowerCase() || "";

// Get appropriate file icon based on extension (shared utility)
export const getFileIcon = (fileName) => {
  const ext = getFileExtension(fileName);
  
  if (powerPointExt.includes(ext)) return pptIcon;
  if (excelExt.includes(ext)) return excelIcon;
  if (wordExt.includes(ext)) return wordIcon;
  if (emailExt.includes(ext)) return emailIcon;
  if (ext === "pdf") return pdfIcon;
  return otherFormat;
};

// Format bytes to human-readable size
export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
